import { ComponentProps } from 'react';
import { GlobalStyles, Palette } from '@mui/material';

export function getGlobalStyles(palette: Palette): ComponentProps<typeof GlobalStyles>['styles'] {
    const name = window.carity.environment.theme?.name;

    const defaultStyle = {
        '.MuiDataGrid-root': { background: `${palette.background.paper} !important` },
        '.MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': { display: 'none' },
        '.MuiPickersTextField-root label': { padding: '0 4px' },
    };

    switch (name) {
        case 'antwerp':
            return {
                ...defaultStyle,
                '.MuiPickersOutlinedInput-root': {
                    height: '48px',
                    border: '1px solid black',
                    '.MuiPickersSectionList-root': { padding: '0' },
                    '.MuiButtonBase-root': { padding: 'auto 8px' },
                },
                '.MuiPickersTextField-root': {
                    label: { padding: '0 0 4px 0' },
                    fieldset: { border: 'none' },
                },
            };
        default:
            return defaultStyle;
    }
}
